/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ErrorLogModel } from '../../models/error-log-model';

export interface Get$Params {
      body?: {
'id'?: number;
}
}

export function Get(http: HttpClient, rootUrl: string, params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorLogModel>> {
  const rb = new RequestBuilder(rootUrl, Get.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ErrorLogModel>;
    })
  );
}

Get.PATH = '/api/ErrorLog/Get';
